import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';
import './skodaCheckboxIcons.scss';

export const SkodaCheckboxIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d="M22 2v20H2V2h22m0-2H0v24h24V0z" />
		<polygon transform="translate(6 6)" points="4.4,8.4 1.2,6.1 0,7.7 4.9,11.2 11.9,1.5 10.3,0.4" />
	</SvgIcon>;

export const SkodaCheckboxBlankIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d="M22 2v20H2V2h22m0-2H0v24h24V0z" />
	</SvgIcon>;

export const SkodaCheckboxCheckerIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<polygon transform="translate(6 6)" points="4.4,8.4 1.2,6.1 0,7.7 4.9,11.2 11.9,1.5 10.3,0.4" />
	</SvgIcon>;

export const SkodaCheckboxCheckerIndeterminateIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d="M7 11L17 11L17 13L7 13L7 11" />
	</SvgIcon>;

export const SkodaCheckboxIndeterminateIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d="M22 2v20H2V2h22m0-2H0v24h24V0zM7 11L17 11L17 13L7 13L7 11" />
	</SvgIcon>;

export const SkodaAnimatedCheckboxIcon: React.FC<SvgIconProps & { value: 'unchecked' | 'checked' | 'indeterminate' }> = (props) => {
	const { value, ...other } = props;
	return (
		<div className={'skoda-animated-checkbox ' + value}>
			<SkodaCheckboxBlankIcon {...other} className={'skoda-animated-checkbox-blank'} />
			<SkodaCheckboxCheckerIcon {...other} className={'skoda-animated-checkbox-checker'} />
			<SkodaCheckboxCheckerIndeterminateIcon {...other} className={'skoda-animated-checkbox-checker-indeterminate'} />
		</div>
	);
};

